import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const ADMIN_URL =
  `${BASE_URL}/rest/v1.0/studio/{studioOwnerName}/admins`;

export const ROSTER_URL =
  `${BASE_URL}/rest/v1.0/studio/{studioOwnerName}/roster?fresh=true`;

export const STUDIO_ACCOUNT_STATUS =
  `${BASE_URL}/rest/v1.0/accounts/status?studioOwnerName={studioOwnerName}&accountType={accountType}`;

export const STUDIO_ADMINS_URL =
  `${BASE_URL}/rest/v1.0/studio/{studioOwnerName}/admins`;

export const STUDIO_PERFORMER =
  `${BASE_URL}/rest/v1.0/studio/{studioOwnerName}/roster/{performerName}`;
